<template>
    <div class='search-box-container'>
        <input class='search-bar' type="text" id="search_bar" name="search-bar" :placeholder="search_placeholder" @keyup="searchOnKeyUp($event)" @focus="focusSearch" v-model="product_search">
        <div class='search-bar-icon' v-if="product_search == ''"><span class="fa-regular fa-magnifying-glass"></span></div>
        <div class='search-bar-icon clear-search-icon' v-if="product_search != ''" @click='clearSearch'><span class="fa-regular fa-xmark"></span></div>
    </div>
</template>

<script>
import SearchResultsCard from '@/ecom/components/navigation/header/search/SearchResultsCard.vue';

import {checkAuth} from "@/global/modules/functions.js";

export default {
    components: {SearchResultsCard},
    props: ['clear_search_watcher'],
    emits: ['productsListener', 'showResultsListener', 'enterPressedListener'],
    data(){
        return{
            product_search: '',
            products: [],
            timeout: null,
            show_results: false,
            current_index: 0,
            number_of_results_per_batch: 12,
            total_product_count: 0,
            search_placeholder: 'Search',
            placeholder_options: [],
            searchbar_config: []
        }
    },
    methods:{
        async searchProducts(clear_results = false){
            let response = await fetch(`/api/elastic-search/products?search_string=${encodeURIComponent(this.product_search)}&search_type=fuzzy&start_index=${this.current_index}&fetch_next=${this.number_of_results_per_batch}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.products = results.products;
                this.total_product_count = results.total_product_count;
                this.$emit('productsListener', this.products, clear_results, this.total_product_count, this.product_search);
              
            }
        },
        searchOnKeyUp(e) {
            clearTimeout(this.timeout); 

            if(e.key == 'Enter'){
                if(this.product_search != ''){
                    this.$emit('enterPressedListener', this.product_search);
                    this.clearSearch();
                    document.getElementById('search_bar').blur();
                    return;
                }
            }
  
            this.timeout = setTimeout(()=>{ 

                if(this.product_search != ''){
                    this.searchProducts();
                }
                else{
                    this.clearSearch();
                }
            }, 200);
            
        },
        focusSearch(){
            if(this.products.length != 0){
                this.show_results = true;
                this.$emit('showResultsListener', this.show_results);
            }
        },
        detectClickOutsideSearchContainer(){
            window.addEventListener('click', (e)=>{   
                if (!document.getElementById('results_container').contains(e.target) && !document.getElementById('search_bar').contains(e.target)){
                    this.show_results = false;
                    this.$emit('showResultsListener', this.show_results);
                } 
            });
        },
        clearSearch(){
            this.show_results = false;
            this.product_search = '';
            this.searchProducts(true);
        },
        typeWriter(i = 0, index = 1, direction = 1) {
            const speed_forwards  = this.searchbar_config.speed_forward;
            const speed_backwards = this.searchbar_config.speed_backward;
            const pause           = this.searchbar_config.pause;

            let speed = speed_forwards;

            if(direction == -1){
                speed = speed_backwards;
            }

            let displayed = this.placeholder_options[i].slice(0, index);
            this.search_placeholder = displayed;

            if (displayed.length >= this.placeholder_options[i].length){ // start removing after pause
                setTimeout(() => this.typeWriter(i, index-1, -1), pause);
            } 
            else if (displayed.length === 0) { // go to next text after pause
                setTimeout(() => this.typeWriter((i+1) % this.placeholder_options.length), pause);
            } 
            else { // continue in the current direction
                setTimeout(() => this.typeWriter(i, index+direction, direction), speed);
            }
        },
        async getSearchbarConfig() {
            let response = await fetch(`/api/searchbar-config`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.searchbar_config = results.searchbar_config;
                if(this.searchbar_config.is_animated) {
                    this.placeholder_options = this.searchbar_config.placeholders.map(x => x.text);
                    this.typeWriter();
                } else {
                    this.search_placeholder = this.searchbar_config?.placeholders?.[0]?.text;
                }
            }
        }

    },
    mounted(){
        this.getSearchbarConfig();
        this.detectClickOutsideSearchContainer();
    },
    watch:{
        'clear_search_watcher': function(){
            this.clearSearch();
        }
    }
}
</script>

<style lang="scss" scoped>

.search-box-container{
    display: flex;
    align-items: center;
    margin-right: 20px;
}

.search-bar{
    width: 350px;
    height: 35px;
    border-radius: 16px;
    border: 1px solid #c7c7c7;
    padding: 1px 35px 1px 20px;
    font-size: 1rem;
    transition: all 700ms;
    z-index: 2;

    font-size: 0.9rem;

    @media(max-width: 1600px){
        width: 300px;
    }

    @media(max-width: 1102px){
        width: 180px;
    }

    @media(max-width: 865px){
        width: 150px;
    }

    @media(max-width: 768px){
        width: 250px;
    }
}

.search-bar-icon{
    z-index: 3;
    margin-left: -30px;
    width: 25px;
    color: var(--primary-colour-2);
}

.clear-search-icon{
    cursor: pointer;
    font-size: 1.1rem;
}

.search-bar:focus{
    outline: none;
}
</style>